import { toPriceView, type PriceView } from "@/lib/money/price-view"
import type { StoreProduct } from "@/platform/api/store-contract"

interface GetPdpPricingParams {
  product: StoreProduct
  variantId?: string
}

export const getPdpPriceView = ({ product, variantId }: GetPdpPricingParams): PriceView | null => {
  const variant = variantId ? product.variants.find((candidate) => candidate.id === variantId) : undefined
  return toPriceView(variant?.price) ?? toPriceView(product.price)
}
